"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShippingCost = void 0;

var _request = _interopRequireDefault(require("./request"));

var getShippingCost = function getShippingCost(jsonobject, onGetAccessToken) {
  return (0, _request.default)('https://shippingcost.financialflows.cimpress.io/v2/costs', onGetAccessToken, 'POST', JSON.stringify(jsonobject));
};

exports.getShippingCost = getShippingCost;